import React from 'react';
import ReactDOM from 'react-dom';
import { Home } from './pages/home';

import * as serviceWorker from './serviceWorker';
import { StepperProvider } from './store/stepper/StepperContext';
import { FormProvider } from './store/surplus/SurPlusContext';

import './styles/main.scss';

import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { Appointment } from './pages/appointment';
import { getConsumer } from './utils';

const consumer = getConsumer();
export const getBasename = () => {
	if (consumer.status) {
		const name = window.location.pathname.split('/')[1] || '/';
		return `${name === '/' ? name : `/${name}`}`;
	} else {
		return window.location.pathname;
	}
};

ReactDOM.render(
    <React.StrictMode>
        <StepperProvider>
					<FormProvider>
						<Router basename={getBasename()}>
							<Switch>
								<Route exact path="/">
									<Home />
								</Route>
								{consumer.status &&
									<Route path="/afspraak" >
										<Appointment />
									</Route>
								}
								<Route path="*" render={() => <Redirect to="/" />} />
							</Switch>
						</Router>
					</FormProvider>
        </StepperProvider>
    </React.StrictMode>,
    document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
